export default "/_next/static/images/product--articles-legacy-769ed5078294d3071247cca82938fe72.svg";